import React from 'react'

import { DialogHeader } from '../../../main/components/dialog'
import FormContent from './FormContent'
import SuccessContent from './SuccessContent'
import { PORTFOLIO_BASE_URL } from './utils'

type SaveToPortfolioProps = {
  ticker: string
  isInlined?: boolean
  onClose?: () => void
}

export function SaveToPortfolio({ ticker, onClose, isInlined }: SaveToPortfolioProps) {
  const [isSubmitted, setIsSubmitted] = React.useState(false)
  const [portfolioUrl, setPortfolioUrl] = React.useState(PORTFOLIO_BASE_URL)

  const handleFromSubmitted = (portfolioId: number) => {
    if (isInlined) {
      // @ts-ignore
      window.location = PORTFOLIO_BASE_URL + portfolioId
      return
    }

    setPortfolioUrl(PORTFOLIO_BASE_URL + portfolioId)
    setIsSubmitted(true)
  }

  return (
    <>
      <DialogHeader onCloseClick={onClose}>Save to Portfolio</DialogHeader>

      {isSubmitted ? (
        <SuccessContent portfolioUrl={portfolioUrl} onClose={onClose} />
      ) : (
        <FormContent ticker={ticker} onClose={onClose} onSubmit={handleFromSubmitted} />
      )}
    </>
  )
}
